import { useMemo } from 'react'
import { observer } from 'mobx-react-lite'

import { AppError, handleUnknownError } from '@jotta/types/AppError'

import { Footer } from '../../Layout/Footer/Footer'

import { BaseErrorPage } from './BaseErrorPage'
import { ErrorPageError } from './ErrorPageError'
import { ErrorPageNotFound } from './ErrorPageNotFound'

function ErrorPageDetails({
  details,
  title,
  resetError,
  error,
  notFound,
}: ErrorPageProps) {
  const appError = useMemo(() => {
    if (!error && notFound) {
      return new AppError({ HTTPStatus: 404 })
    }
    return handleUnknownError(error)
  }, [error, notFound])

  if (details) {
    return (
      <BaseErrorPage reportError={appError} title={title}>
        {details}
      </BaseErrorPage>
    )
  }

  if (appError.isNotFound) {
    return <ErrorPageNotFound resetError={resetError} />
  }

  return (
    <ErrorPageError error={appError} resetError={resetError} title={title} />
  )
}

export interface ErrorPageProps {
  error?: unknown
  notFound?: boolean
  resetError?: () => void
  hideFooter?: boolean
  title?: React.ReactNode
  details?: React.ReactNode
}
export const ErrorPage = observer(function ErrorPage({
  hideFooter = false,
  ...props
}: ErrorPageProps) {
  return (
    <div className="grid h-full grid-rows-[1fr_min-content] place-items-center items-center">
      <ErrorPageDetails {...props} />
      {!hideFooter && <Footer />}
    </div>
  )
})
